(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[487,7477,7057],{

/***/ 86056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const NavContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
NavContext.displayName = 'NavContext';
/* harmony default export */ __webpack_exports__["Z"] = (NavContext);

/***/ }),

/***/ 73716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useNavItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78146);
/* harmony import */ var _NavContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86056);
/* harmony import */ var _SelectableContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87126);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70861);
/* harmony import */ var _DataKey__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52747);
/* harmony import */ var _TabContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
const _excluded = ["as", "active", "eventKey"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }










function useNavItem({
  key,
  onClick,
  active,
  id,
  role,
  disabled
}) {
  const parentOnSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_SelectableContext__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
  const navContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_NavContext__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  const tabContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_TabContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
  let isActive = active;
  const props = {
    role
  };

  if (navContext) {
    if (!role && navContext.role === 'tablist') props.role = 'tab';
    const contextControllerId = navContext.getControllerId(key != null ? key : null);
    const contextControlledId = navContext.getControlledId(key != null ? key : null); // @ts-ignore

    props[(0,_DataKey__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)('event-key')] = key;
    props.id = contextControllerId || id;
    isActive = active == null && key != null ? navContext.activeKey === key : active;
    /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */

    if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
  }

  if (props.role === 'tab') {
    if (disabled) {
      props.tabIndex = -1;
      props['aria-disabled'] = true;
    }

    if (isActive) {
      props['aria-selected'] = isActive;
    } else {
      props.tabIndex = -1;
    }
  }

  props.onClick = (0,_restart_hooks_useEventCallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(e => {
    if (disabled) return;
    onClick == null ? void 0 : onClick(e);

    if (key == null) {
      return;
    }

    if (parentOnSelect && !e.isPropagationStopped()) {
      parentOnSelect(key, e);
    }
  });
  return [props, {
    isActive
  }];
}
const NavItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
    as: Component = _Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,
    active,
    eventKey
  } = _ref,
      options = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [props, meta] = useNavItem(Object.assign({
    key: (0,_SelectableContext__WEBPACK_IMPORTED_MODULE_3__/* .makeEventKey */ .h)(eventKey, options.href),
    active
  }, options)); // @ts-ignore

  props[(0,_DataKey__WEBPACK_IMPORTED_MODULE_6__/* .dataAttr */ .PB)('active')] = meta.isActive;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, Object.assign({}, options, props, {
    ref: ref
  }));
});
NavItem.displayName = 'NavItem';
/* harmony default export */ __webpack_exports__["Z"] = (NavItem);

/***/ }),

/***/ 87126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ makeEventKey; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const SelectableContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
const makeEventKey = (eventKey, href = null) => {
  if (eventKey != null) return String(eventKey);
  return href || null;
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectableContext);

/***/ }),

/***/ 76626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const TabContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/* harmony default export */ __webpack_exports__["Z"] = (TabContext);

/***/ }),

/***/ 70710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyReveal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
"use client";


const DefaultShimmer = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "animate-pulse bg-gray-300 h-6 w-full rounded-lg"
    });
function LazyReveal({ children , shimmer , rootMargin ="0px" , threshold =0.1 , className , onVisible , id , style  }) {
    const { 0: visible , 1: setVisible  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const observerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!wrapperRef.current) return;
        observerRef.current = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry.isIntersecting) {
                setVisible(true);
                onVisible && onVisible();
                observerRef.current?.disconnect();
            }
        }, {
            rootMargin,
            threshold
        });
        observerRef.current.observe(wrapperRef.current);
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, [
        rootMargin,
        threshold
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        className: className,
        id: id,
        style: style,
        children: visible ? children : shimmer || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DefaultShimmer, {})
    });
}


/***/ }),

/***/ 79782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70710);










const AccomplishSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().accomplishSection),
        style: {
            background: `linear-gradient(0deg, ${eventData?.accomplishSection?.sectionBgColorBottom || "#EEF2FB"} 50%, ${eventData?.accomplishSection?.sectionBgColorTop || "#ffffff"} 0)`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            style: {
                                backgroundColor: `${eventData?.accomplishSection?.sectionBgColor}`
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || eventData?.accomplishSection?.sectionTitleColor || "#fff"
                                        },
                                        children: eventData?.accomplishSection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: eventData.accomplishSection?.button?.label || "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccomplishSection);


/***/ }),

/***/ 54455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98196);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32866);
/* harmony import */ var _LazyReveal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70710);










const GrabChanceSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,_hooks_useZipmeLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LazyReveal__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        style: {
            background: `linear-gradient(0deg, ${eventData?.grabChanceSection?.sectionBgColorBottom || "#F7F8F7"} 50%, ${eventData?.grabChanceSection?.sectionBgColorTop || "#DBD9FC"} 0)`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            style: {
                                backgroundColor: `${eventData?.grabChanceSection?.sectionBgColor}`
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || eventData?.grabChanceSection?.sectionTitleColor || "#fff"
                                        },
                                        children: eventData?.grabChanceSection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__/* .isFrappeOrJotFormClass */ .gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: eventData.grabChanceSection?.button?.label || "Register Now"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                                            dangerouslySetInnerHTML: {
                                                __html: `window.lintrk('track', { conversion_id: 6870956 });`
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GrabChanceSection);


/***/ }),

/***/ 80487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OverseasEdutionFair_LandingPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/educationFair.module.scss
var educationFair_module = __webpack_require__(21174);
var educationFair_module_default = /*#__PURE__*/__webpack_require__.n(educationFair_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
;// CONCATENATED MODULE: ./components/OverseasEdutionFair/eduFairWhyAttent.tsx







const EduFairWhyAttend = ({ data  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "why-attend",
        className: (educationFair_module_default()).whyattend,
        style: {
            backgroundColor: data?.sectionBgColor || "#ffffff"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (educationFair_module_default()).maindiv,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (educationFair_module_default()).heading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: data?.sectionTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: (educationFair_module_default()).contentDiv,
                        children: data?.pointImage?.length > 0 && data?.pointImage.map((point, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xl: 6,
                                lg: 6,
                                md: 6,
                                sm: 12,
                                xs: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (educationFair_module_default()).mainBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (educationFair_module_default()).box,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (educationFair_module_default()).img,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: point?.imageUrl,
                                                    width: 30,
                                                    height: 30,
                                                    className: (educationFair_module_default()).studImg,
                                                    alt: "handshake.png"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (educationFair_module_default()).para,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: point?.title
                                                })
                                            })
                                        ]
                                    })
                                })
                            });
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var eduFairWhyAttent = (EduFairWhyAttend);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
;// CONCATENATED MODULE: ./components/OverseasEdutionFair/eduFairStudScholarshi.tsx










const EduFairStudentScholarship = ({ title , scholarshipData , sectionBgColor  })=>{
    const sliderRef = (0,react.useRef)(null);
    const settings = {
        dotsClass: (educationFair_module_default()).sliderDots,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "top-scholarship",
        className: (educationFair_module_default()).topScholarship,
        style: {
            background: sectionBgColor || "#EEF2FB"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (educationFair_module_default()).heading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (educationFair_module_default()).stuSchSlider,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                            ...settings,
                            className: (educationFair_module_default()).slider,
                            ref: sliderRef,
                            children: scholarshipData?.length > 0 && scholarshipData.map((scholarship, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (educationFair_module_default()).sliderCardDiv,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                        className: (educationFair_module_default()).cardCust,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (educationFair_module_default()).studeImgDiv,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: scholarship?.studentImageUrl,
                                                    width: 160,
                                                    height: 160,
                                                    className: (educationFair_module_default()).cardImg,
                                                    alt: "University Akshay Singh Chouhan"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                className: (educationFair_module_default()).cardBody,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (educationFair_module_default()).stuName,
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: scholarship?.studentName
                                                            }),
                                                            " "
                                                        ]
                                                    }),
                                                    scholarship?.points?.length > 0 && scholarship?.points.map((point, index)=>{
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (educationFair_module_default()).StdDetail,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            style: index === 3 ? {
                                                                                color: "#1321C5"
                                                                            } : {},
                                                                            children: point?.label
                                                                        }),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    style: index === 3 ? {
                                                                        color: "#1321C5"
                                                                    } : {},
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: point?.value
                                                                        }),
                                                                        " "
                                                                    ]
                                                                })
                                                            ]
                                                        });
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index);
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var eduFairStudScholarshi = (EduFairStudentScholarship);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairWhyChoosekc.tsx
var eduFairWhyChoosekc = __webpack_require__(17477);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairKcByNumber.tsx
var eduFairKcByNumber = __webpack_require__(17057);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairStudTestimonials.tsx
var eduFairStudTestimonials = __webpack_require__(91071);
;// CONCATENATED MODULE: ./components/OverseasEdutionFair/eduFairParticipatingUniv.tsx











const EduFairParticipatingUniversity = ({ data , sectionTitle , sectionBgColor  })=>{
    const sliderRef = (0,react.useRef)(null);
    const { 0: selectedCountry , 1: setSelectedCountry  } = (0,react.useState)(data[0]);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        rows: 5,
        slidesPerRow: 2,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    rows: 5,
                    slidesPerRow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    infinite: true,
                    arrows: false,
                    rows: 4,
                    slidesPerRow: 1,
                    dotsClass: (educationFair_module_default()).sliderDots,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: true,
                    rows: 4,
                    slidesPerRow: 1,
                    dotsClass: (educationFair_module_default()).sliderDots,
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "part-univer",
        className: (educationFair_module_default()).partUni,
        style: {
            backgroundColor: sectionBgColor || "#DBD9FC"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (educationFair_module_default()).heading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (educationFair_module_default()).clickTabsCountry,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: data?.length > 0 && data.map((country)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                lg: 3,
                                xl: 3,
                                md: 4,
                                sm: 6,
                                xs: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: `${(educationFair_module_default()).countryFlag} ${country.id === selectedCountry.id ? (educationFair_module_default()).activeClass : ""}`,
                                    onClick: ()=>setSelectedCountry(country),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (educationFair_module_default()).countryBox,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: (educationFair_module_default()).flag,
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: country?.flagUrl,
                                                        width: 55,
                                                        height: 30,
                                                        className: (educationFair_module_default()).flaImg,
                                                        alt: "usaflag.svg"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (educationFair_module_default()).flagsapn,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: country?.countryName
                                                })
                                            })
                                        ]
                                    })
                                })
                            });
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "show-univer-logo",
                    className: (educationFair_module_default()).ClickshowUniLogo,
                    children: [
                        /*#__PURE__*/ (0,react.createElement)(lib/* default */.Z, {
                            ...settings,
                            className: (educationFair_module_default()).slider,
                            ref: sliderRef,
                            key: selectedCountry?.id
                        }, selectedCountry?.universities?.length > 0 ? selectedCountry?.universities.map((university)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (educationFair_module_default()).unilogoslider,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (educationFair_module_default()).uniLogodiv,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (educationFair_module_default()).uniImg,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                src: university?.imageUrl,
                                                width: 58,
                                                height: 53,
                                                className: (educationFair_module_default()).UniFlagImg,
                                                alt: "UniversityofKansasKansas.png"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (educationFair_module_default()).uniName,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: university?.title
                                            })
                                        })
                                    ]
                                })
                            });
                        }) : "No Universities"),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (educationFair_module_default()).arrowsClass,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (educationFair_module_default()).btcircle,
                                    onClick: ()=>sliderRef?.current?.slickPrev(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/left-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "left-arrow"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (educationFair_module_default()).btcircle,
                                    onClick: ()=>sliderRef?.current?.slickNext(),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: "/new-images/right-arrow.svg",
                                        height: 17,
                                        width: 10,
                                        alt: "right-arrow"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var eduFairParticipatingUniv = (EduFairParticipatingUniversity);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairFooter.tsx
var eduFairFooter = __webpack_require__(74050);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 3 modules
var Nav = __webpack_require__(80957);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./hooks/useZipmeLink.tsx
var useZipmeLink = __webpack_require__(98196);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/OverseasEdutionFair/BannerSection.tsx












const BannerSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: eventData?.mainImageUrl,
                    fetchPriority: "high"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (educationFair_module_default()).banner,
                style: {
                    backgroundColor: eventData?.bannerBottomBgColor || "#fff"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (educationFair_module_default()).nav,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: eventData?.logoUrl || "/images/educationfair/kc_logo.svg",
                                            width: eventData?.logoUrl ? 250 : 180,
                                            height: eventData?.logoUrl ? 80 : 45,
                                            className: (educationFair_module_default()).navLogo,
                                            alt: "kclogo"
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (educationFair_module_default()).maincontent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 6,
                                        lg: 6,
                                        md: 12,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: `${(educationFair_module_default()).mainSectionBg} ${(educationFair_module_default()).fairdetails}`,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (educationFair_module_default()).heading,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                            style: {
                                                                color: eventData?.titleTextColor || "#fff"
                                                            },
                                                            children: eventData?.attendTitleText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            style: {
                                                                color: eventData?.titleTextColor || "#fff"
                                                            },
                                                            children: eventData?.eventName
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            style: {
                                                                color: eventData?.subTitleTextColor || "#FDA64F"
                                                            },
                                                            children: eventData?.subTitle
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (educationFair_module_default()).sponserdSecdesk,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: eventData?.copoweredSection?.sectionTitle
                                                        }),
                                                        eventData?.copoweredSection?.sectionImages?.length > 0 && eventData?.copoweredSection?.sectionImages.map((images)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: images?.imageUrl,
                                                                width: 110,
                                                                height: 40,
                                                                alt: "co-powered image"
                                                            }))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (educationFair_module_default()).fairdetails,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (educationFair_module_default()).events,
                                                            children: [
                                                                eventData?.dateAndTime && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (educationFair_module_default()).time,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (educationFair_module_default()).icon,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: "/images/educationfair/addre.png",
                                                                                width: 30,
                                                                                height: 30,
                                                                                className: (educationFair_module_default()).studImg,
                                                                                alt: "addre.png"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                style: {
                                                                                    color: eventData?.dateTimeTextColor || "#fff"
                                                                                },
                                                                                children: eventData?.dateAndTime
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                eventData?.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (educationFair_module_default()).location,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (educationFair_module_default()).icon,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: "/images/educationfair/location.png",
                                                                                width: 30,
                                                                                height: 30,
                                                                                className: (educationFair_module_default()).studImg,
                                                                                alt: "location.png"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                style: {
                                                                                    color: eventData?.locationTextColor || "#fff"
                                                                                },
                                                                                children: eventData?.location
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (educationFair_module_default()).regBtn,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                id: "enquirebt",
                                                                variant: "primary",
                                                                size: "lg",
                                                                onClick: ()=>{
                                                                    !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                                                },
                                                                className: `${eventData?.meta?.jotforms[0]?.jotformid ? `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""} ${(educationFair_module_default()).btnReg}`,
                                                                children: "Register Now"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 6,
                                        lg: 6,
                                        md: 12,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (educationFair_module_default()).bannerStudDiv,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (educationFair_module_default()).bg,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: eventData?.mainImageUrl,
                                                    width: 640,
                                                    height: 427,
                                                    className: (educationFair_module_default()).studImg,
                                                    alt: "location.png"
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var OverseasEdutionFair_BannerSection = (BannerSection);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/GrabChanceSection.tsx
var GrabChanceSection = __webpack_require__(54455);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./components/LazyReveal.tsx
var LazyReveal = __webpack_require__(70710);
;// CONCATENATED MODULE: ./components/OverseasEdutionFair/WhoWillMeetSection.tsx













const WhoWillMeetSection = ({ eventData  })=>{
    const sliderRef = (0,react.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: true,
        autoplaySpeed: constants/* sliderSpeed.desktopAutoplaySpeed */.Y$.desktopAutoplaySpeed,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplaySpeed: constants/* sliderSpeed.mobileAutoplaySpeed */.Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
        className: (educationFair_module_default()).whoWillYouMeet,
        style: {
            background: eventData?.whoYouMeetSection?.sectionBgColor || "#F7F8F7"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (educationFair_module_default()).heading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: eventData?.whoYouMeetSection?.sectionTitle
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (educationFair_module_default()).whoyoumeetslider,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                ...settings,
                                className: (educationFair_module_default()).slider,
                                ref: sliderRef,
                                children: eventData?.whoYouMeetSection?.whoYouMeet?.length > 0 && eventData?.whoYouMeetSection?.whoYouMeet.map((section)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 3,
                                        lg: 3,
                                        md: 3,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                            className: (educationFair_module_default()).card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (educationFair_module_default()).cardImgDiv,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: section?.imagePath,
                                                        width: 313,
                                                        height: 207,
                                                        className: (educationFair_module_default()).cardImg,
                                                        layout: "responsive",
                                                        alt: "University-Representative.png"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                    className: (educationFair_module_default()).cardBody,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                            children: section?.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: section?.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    });
                                })
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var OverseasEdutionFair_WhoWillMeetSection = (WhoWillMeetSection);

;// CONCATENATED MODULE: ./components/OverseasEdutionFair/SpecialOffersSection.tsx










const SpecialOffersSection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
        className: (educationFair_module_default()).studentSpecialOffer,
        style: {
            background: eventData?.specialOffersSection?.sectionBgColor || "#DBD9FC"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (educationFair_module_default()).heading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: eventData?.specialOffersSection?.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (educationFair_module_default()).stuImg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: eventData?.specialOffersSection?.sectionImage,
                                    width: 500,
                                    height: 430,
                                    alt: "stuImg.png"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (educationFair_module_default()).OffersContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: (educationFair_module_default()).ulItem,
                                        children: eventData?.specialOffersSection?.offers?.length > 0 && eventData?.specialOffersSection?.offers.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: (educationFair_module_default()).liItem,
                                                children: offer
                                            }, index))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (educationFair_module_default()).anchor,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: ()=>{
                                                !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                            },
                                            className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                            children: "Register Now"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var OverseasEdutionFair_SpecialOffersSection = (SpecialOffersSection);

;// CONCATENATED MODULE: ./components/OverseasEdutionFair/StepUpSection.tsx








const StepUpSection = ({ eventData  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
        className: (educationFair_module_default()).ScholarshipStudent,
        style: {
            background: eventData?.stepUpSection?.sectionBgColor || "#FBE7CC"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (educationFair_module_default()).heading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: eventData?.stepUpSection?.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "d-block d-sm-none mb-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (educationFair_module_default()).schStd,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: eventData?.stepUpSection?.sectionImage,
                                            width: 380,
                                            height: 380,
                                            alt: "scholarshipStud.png",
                                            className: (educationFair_module_default()).schStImg
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (educationFair_module_default()).SchContent,
                                    children: eventData?.stepUpSection?.offers?.length > 0 && eventData?.stepUpSection?.offers.map((offer)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: offer
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xl: 6,
                            lg: 6,
                            md: 6,
                            sm: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (educationFair_module_default()).schStd + " d-none d-sm-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: eventData?.stepUpSection?.sectionImage,
                                    width: 380,
                                    height: 380,
                                    alt: "scholarshipStud.png",
                                    className: (educationFair_module_default()).schStImg
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var OverseasEdutionFair_StepUpSection = (StepUpSection);

// EXTERNAL MODULE: ./components/OverseasEdutionFair/AccomplishSection.tsx
var AccomplishSection = __webpack_require__(79782);
;// CONCATENATED MODULE: ./components/OverseasEdutionFair/LandingPage.tsx


















const LandingPage = (props)=>{
    const eventData = props.pageData[0];
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--event-bgcolor", eventData?.backgroundColor || "#6C48F0");
    }, []);
    const renderSwitchData = ()=>{
        switch(eventData.selectTemplate){
            case "template1":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_BannerSection, {
                            eventData: eventData
                        }),
                        eventData?.whyAttendSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            className: (educationFair_module_default()).ngpWhyAttend,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairWhyAttent, {
                                data: eventData?.whyAttendSection
                            })
                        }),
                        eventData?.participatingSection?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairParticipatingUniv, {
                                data: eventData?.participatingSection,
                                sectionTitle: eventData?.participatingSectionTitle,
                                sectionBgColor: eventData?.participatingSectionBgColor
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GrabChanceSection/* default */.Z, {
                            eventData: eventData
                        }),
                        eventData?.whoYouMeetSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_WhoWillMeetSection, {
                            eventData: eventData
                        }),
                        eventData?.specialOffersSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_SpecialOffersSection, {
                            eventData: eventData
                        }),
                        eventData?.stepUpSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_StepUpSection, {
                            eventData: eventData
                        }),
                        eventData?.topScholarships?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            className: (educationFair_module_default()).ngpStuSchol,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairStudScholarshi, {
                                title: eventData?.scholarshipTitle,
                                scholarshipData: eventData?.topScholarships,
                                sectionBgColor: eventData?.scholarshipSectionBgColor
                            })
                        }),
                        eventData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairWhyChoosekc["default"], {
                                data: eventData?.whyChooseKc
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccomplishSection/* default */.Z, {
                            eventData: eventData
                        }),
                        eventData?.studentsSaySection && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairStudTestimonials["default"], {
                                data: eventData?.studentsSaySection
                            })
                        }),
                        eventData?.kcNumbersSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairKcByNumber["default"], {
                                data: eventData?.kcNumbersSection
                            })
                        }),
                        eventData?.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairFooter/* default */.Z, {
                                data: eventData?.footer,
                                jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                                externalLink: eventData?.externalLink
                            })
                        })
                    ]
                });
            case "template2":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_BannerSection, {
                            eventData: eventData
                        }),
                        eventData?.stepUpSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_StepUpSection, {
                            eventData: eventData
                        }),
                        eventData?.whoYouMeetSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_WhoWillMeetSection, {
                            eventData: eventData
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GrabChanceSection/* default */.Z, {
                            eventData: eventData
                        }),
                        eventData?.specialOffersSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasEdutionFair_SpecialOffersSection, {
                            eventData: eventData
                        }),
                        eventData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairWhyChoosekc["default"], {
                                data: eventData?.whyChooseKc
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccomplishSection/* default */.Z, {
                            eventData: eventData
                        }),
                        eventData?.whyAttendSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            className: (educationFair_module_default()).ngpWhyAttend,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairWhyAttent, {
                                data: eventData?.whyAttendSection
                            })
                        }),
                        eventData?.studentsSaySection && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairStudTestimonials["default"], {
                                data: eventData?.studentsSaySection
                            })
                        }),
                        eventData?.kcNumbersSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairKcByNumber["default"], {
                                data: eventData?.kcNumbersSection
                            })
                        }),
                        eventData?.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyReveal/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairFooter/* default */.Z, {
                                data: eventData?.footer,
                                jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                                externalLink: eventData?.externalLink
                            })
                        })
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.pageData?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...props.pageData[0].meta
            }),
            renderSwitchData()
        ]
    });
};
/* harmony default export */ var OverseasEdutionFair_LandingPage = (LandingPage);


/***/ }),

/***/ 17057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _VisibilitySensorComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54820);







const EduFairKcByNumber = ({ data  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "edu-fair-kcbynumber",
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().kcByNumber),
        style: {
            background: data?.sectionBgColor || "#FFFFFF"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().number),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: data?.coreTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: data?.sections?.length > 0 && data?.sections.map((section)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                xl: 4,
                                lg: 4,
                                md: 4,
                                sm: 12,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            style: {
                                                color: section?.color
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VisibilitySensorComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                end: parseInt(section?.countText.replace(/[,+Cr]/g, "")),
                                                suffix: section?.countText.includes("Cr+") ? " Cr+" : section?.countText.includes("+") ? "+" : ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: section?.sectionTitle
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: section?.sectionDesc
                                        })
                                    ]
                                })
                            });
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (EduFairKcByNumber);


/***/ }),

/***/ 17477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21174);
/* harmony import */ var _styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);







const WhyChoosKcStudyAbroad = ({ data  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "whychoos-kcstudyabroad",
        className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().choosekc),
        style: {
            background: data?.sectionBgColor || "#ffffff"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().whykc),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: data?.sectionTitle
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: data?.pointImage?.length > 0 && data?.pointImage.map((point)=>{
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                xl: 4,
                                lg: 4,
                                md: 4,
                                sm: 12,
                                xs: 6,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_styles_educationFair_module_scss__WEBPACK_IMPORTED_MODULE_3___default().img),
                                            children: [
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                    src: point?.imageUrl,
                                                    width: 100,
                                                    height: 110,
                                                    alt: "Free Counselling"
                                                }),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                children: point?.title
                                            })
                                        })
                                    ]
                                })
                            });
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WhyChoosKcStudyAbroad);


/***/ }),

/***/ 54820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VisibilitySensorComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
;// CONCATENATED MODULE: ./components/CountUp.tsx


const CountUpComp = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
        duration: 0.4,
        end: end,
        redraw: true,
        suffix: suffix || "",
        enableScrollSpy: true,
        separator: ","
    });
};
/* harmony default export */ var CountUp = (CountUpComp);

;// CONCATENATED MODULE: ./components/VisibilitySensorComponent.tsx



const VisibilitySensorComponent = (props)=>{
    const { end , suffix  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
            partialVisibility: true,
            offset: {
                bottom: 10,
                top: 10
            },
            children: ({ isVisible  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: isVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CountUp, {
                        end: end,
                        suffix: suffix
                    }) : end
                })
        })
    });
};
/* harmony default export */ var components_VisibilitySensorComponent = (VisibilitySensorComponent);


/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = all;

var _createChainableTypeChecker = __webpack_require__(82613);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),

/***/ 82613:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 49059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'CardHeaderContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ }),

/***/ 80957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ react_bootstrap_esm_Nav; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types-extra/lib/all.js
var lib_all = __webpack_require__(4391);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/dom-helpers/esm/querySelectorAll.js
var querySelectorAll = __webpack_require__(60930);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useForceUpdate.js

/**
 * Returns a function that triggers a component update. the hook equivalent to
 * `this.forceUpdate()` in a class component. In most cases using a state value directly
 * is preferable but may be required in some advanced usages of refs for interop or
 * when direct DOM manipulation is required.
 *
 * ```ts
 * const forceUpdate = useForceUpdate();
 *
 * const updateOnClick = useCallback(() => {
 *  forceUpdate()
 * }, [forceUpdate])
 *
 * return <button type="button" onClick={updateOnClick}>Hi there</button>
 * ```
 */

function useForceUpdate() {
  // The toggling state value is designed to defeat React optimizations for skipping
  // updates when they are stricting equal to the last state value
  var _useReducer = (0,react.useReducer)(function (state) {
    return !state;
  }, false),
      dispatch = _useReducer[1];

  return dispatch;
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMergedRefs.js
var useMergedRefs = __webpack_require__(35654);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/NavContext.js
var NavContext = __webpack_require__(86056);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/SelectableContext.js
var SelectableContext = __webpack_require__(87126);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/TabContext.js
var TabContext = __webpack_require__(76626);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/DataKey.js
var DataKey = __webpack_require__(52747);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/NavItem.js
var NavItem = __webpack_require__(73716);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Nav.js
const _excluded = ["as", "onSelect", "activeKey", "role", "onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }













// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const EVENT_KEY_ATTR = (0,DataKey/* dataAttr */.PB)('event-key');
const Nav = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    onSelect,
    activeKey,
    role,
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
  // and don't want to reset the set in the effect
  const forceUpdate = useForceUpdate();
  const needsRefocusRef = (0,react.useRef)(false);
  const parentOnSelect = (0,react.useContext)(SelectableContext/* default */.Z);
  const tabContext = (0,react.useContext)(TabContext/* default */.Z);
  let getControlledId, getControllerId;

  if (tabContext) {
    role = role || 'tablist';
    activeKey = tabContext.activeKey; // TODO: do we need to duplicate these?

    getControlledId = tabContext.getControlledId;
    getControllerId = tabContext.getControllerId;
  }

  const listNode = (0,react.useRef)(null);

  const getNextActiveTab = offset => {
    const currentListNode = listNode.current;
    if (!currentListNode) return null;
    const items = (0,querySelectorAll/* default */.Z)(currentListNode, `[${EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
    const activeChild = currentListNode.querySelector('[aria-selected=true]');
    if (!activeChild || activeChild !== document.activeElement) return null;
    const index = items.indexOf(activeChild);
    if (index === -1) return null;
    let nextIndex = index + offset;
    if (nextIndex >= items.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = items.length - 1;
    return items[nextIndex];
  };

  const handleSelect = (key, event) => {
    if (key == null) return;
    onSelect == null ? void 0 : onSelect(key, event);
    parentOnSelect == null ? void 0 : parentOnSelect(key, event);
  };

  const handleKeyDown = event => {
    onKeyDown == null ? void 0 : onKeyDown(event);

    if (!tabContext) {
      return;
    }

    let nextActiveChild;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextActiveChild = getNextActiveTab(-1);
        break;

      case 'ArrowRight':
      case 'ArrowDown':
        nextActiveChild = getNextActiveTab(1);
        break;

      default:
        return;
    }

    if (!nextActiveChild) return;
    event.preventDefault();
    handleSelect(nextActiveChild.dataset[(0,DataKey/* dataProp */.$F)('EventKey')] || null, event);
    needsRefocusRef.current = true;
    forceUpdate();
  };

  (0,react.useEffect)(() => {
    if (listNode.current && needsRefocusRef.current) {
      const activeChild = listNode.current.querySelector(`[${EVENT_KEY_ATTR}][aria-selected=true]`);
      activeChild == null ? void 0 : activeChild.focus();
    }

    needsRefocusRef.current = false;
  });
  const mergedRef = (0,useMergedRefs/* default */.Z)(ref, listNode);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SelectableContext/* default.Provider */.Z.Provider, {
    value: handleSelect,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavContext/* default.Provider */.Z.Provider, {
      value: {
        role,
        // used by NavLink to determine it's role
        activeKey: (0,SelectableContext/* makeEventKey */.h)(activeKey),
        getControlledId: getControlledId || noop,
        getControllerId: getControllerId || noop
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, Object.assign({}, props, {
        onKeyDown: handleKeyDown,
        ref: mergedRef,
        role: role
      }))
    })
  });
});
Nav.displayName = 'Nav';
/* harmony default export */ var esm_Nav = (Object.assign(Nav, {
  Item: NavItem/* default */.Z
}));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/NavbarContext.js
 // TODO: check

const context = /*#__PURE__*/react.createContext(null);
context.displayName = 'NavbarContext';
/* harmony default export */ var NavbarContext = (context);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/NavItem.js
var esm_NavItem = __webpack_require__(41244);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/NavLink.js
var NavLink = __webpack_require__(14691);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Nav.js












const defaultProps = {
  justify: false,
  fill: false
};
const Nav_Nav = /*#__PURE__*/react.forwardRef((uncontrolledProps, ref) => {
  const {
    as = 'div',
    bsPrefix: initialBsPrefix,
    variant,
    fill,
    justify,
    navbar,
    navbarScroll,
    className,
    activeKey,
    ...props
  } = (0,esm/* useUncontrolled */.Ch)(uncontrolledProps, {
    activeKey: 'onSelect'
  });
  const bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(initialBsPrefix, 'nav');
  let navbarBsPrefix;
  let cardHeaderBsPrefix;
  let isNavbar = false;
  const navbarContext = (0,react.useContext)(NavbarContext);
  const cardHeaderContext = (0,react.useContext)(CardHeaderContext/* default */.Z);

  if (navbarContext) {
    navbarBsPrefix = navbarContext.bsPrefix;
    isNavbar = navbar == null ? true : navbar;
  } else if (cardHeaderContext) {
    ({
      cardHeaderBsPrefix
    } = cardHeaderContext);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_Nav, {
    as: as,
    ref: ref,
    activeKey: activeKey,
    className: classnames_default()(className, {
      [bsPrefix]: !isNavbar,
      [`${navbarBsPrefix}-nav`]: isNavbar,
      [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
      [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
      [`${bsPrefix}-${variant}`]: !!variant,
      [`${bsPrefix}-fill`]: fill,
      [`${bsPrefix}-justified`]: justify
    }),
    ...props
  });
});
Nav_Nav.displayName = 'Nav';
Nav_Nav.defaultProps = defaultProps;
/* harmony default export */ var react_bootstrap_esm_Nav = (Object.assign(Nav_Nav, {
  Item: esm_NavItem/* default */.Z,
  Link: NavLink/* default */.Z
}));

/***/ }),

/***/ 41244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createWithBsPrefix__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66611);

/* harmony default export */ __webpack_exports__["Z"] = ((0,_createWithBsPrefix__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)('nav-item'));

/***/ }),

/***/ 14691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23646);
/* harmony import */ var _restart_ui_NavItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73716);
/* harmony import */ var _restart_ui_SelectableContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87126);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







const defaultProps = {
  disabled: false
};
const NavLink = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  as: Component = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  active,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'nav-link');
  const [navItemProps, meta] = (0,_restart_ui_NavItem__WEBPACK_IMPORTED_MODULE_5__/* .useNavItem */ .v)({
    key: (0,_restart_ui_SelectableContext__WEBPACK_IMPORTED_MODULE_6__/* .makeEventKey */ .h)(eventKey, props.href),
    active,
    ...props
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, { ...props,
    ...navItemProps,
    ref: ref,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, bsPrefix, props.disabled && 'disabled', meta.isActive && 'active')
  });
});
NavLink.displayName = 'NavLink';
NavLink.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (NavLink);

/***/ })

}]);